import { cn } from '@noor/lib/cn';

type IconProps = React.ComponentProps<'svg'>;

/**
 * Pickup "target" glyph — a bold hollow ring with a filled center dot, matching
 * the Figma single-drop pickup marker (node 236:7381). Inherits `currentColor`.
 */
export function DeliveryPickupTargetIcon({ className, ...props }: IconProps) {
  return (
    <svg
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={cn('size-3 shrink-0', className)}
      {...props}
    >
      <circle cx="6" cy="6" r="4.5" stroke="currentColor" strokeWidth="2" />
      <circle cx="6" cy="6" r="1.75" fill="currentColor" />
    </svg>
  );
}

/**
 * Pickup "location pin" glyph — the orange teardrop marker used on multi-drop
 * pickup rows (node 236:7385). Inherits `currentColor`.
 */
export function DeliveryPickupPinIcon({ className, ...props }: IconProps) {
  return (
    <svg
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={cn('size-3 shrink-0', className)}
      {...props}
    >
      <path
        d="M6 .75c-2.07 0-3.75 1.63-3.75 3.64 0 2.5 3.28 6.1 3.42 6.25a.45.45 0 0 0 .66 0c.14-.15 3.42-3.75 3.42-6.25C9.75 2.38 8.07.75 6 .75Z"
        fill="currentColor"
      />
      <circle cx="6" cy="4.4" r="1.4" fill="#fff" />
    </svg>
  );
}

/**
 * Dropoff "checkered flag" glyph, matching the Figma dropoff marker
 * (node 236:7385 flag). Inherits `currentColor`.
 */
export function DeliveryDropoffFlagIcon({ className, ...props }: IconProps) {
  return (
    <svg
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={cn('size-3 shrink-0', className)}
      {...props}
    >
      <path d="M2.4 1v10" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
      <rect x="3.2" y="1.5" width="6.4" height="4.6" rx="0.4" fill="currentColor" />
      <g fill="#fff">
        <rect x="3.2" y="1.5" width="1.6" height="1.15" />
        <rect x="6.4" y="1.5" width="1.6" height="1.15" />
        <rect x="4.8" y="2.65" width="1.6" height="1.15" />
        <rect x="8" y="2.65" width="1.6" height="1.15" />
        <rect x="3.2" y="3.8" width="1.6" height="1.15" />
        <rect x="6.4" y="3.8" width="1.6" height="1.15" />
        <rect x="4.8" y="4.95" width="1.6" height="1.15" />
        <rect x="8" y="4.95" width="1.6" height="1.15" />
      </g>
    </svg>
  );
}
